import React from 'react';
import * as Icons from "react-icons/fa6";

interface DynamicFaIconProps {
    name: string; // Tipe string untuk properti name
}

const DynamicFaIcon: React.FC<DynamicFaIconProps> = ({ name }) => {
    const IconComponent = Icons[name as keyof typeof Icons]; // Cast name ke union type yang sesuai

    if (!IconComponent) {
        return <Icons.FaImage />;
    }

    return <IconComponent />;
};

export default DynamicFaIcon;